import React from 'react';
import styled from 'styled-components';
import KubitTooltip from '../../../../../components/KubitTooltip';

interface IProps {
  selectedValues: string[];
}

const Value = styled.div`
  font-weight: 600;
`;

const UsersFilterLabel = ({ selectedValues }: IProps) => {
  const value =
    selectedValues.length > 0 ? `${selectedValues.length} Selected` : 'All';

  return (
    <KubitTooltip
      content={<>{selectedValues.join(', ')}</>}
      noOpenDelay={true}
      disabled={!selectedValues.length}
    >
      <Value>{value}</Value>
    </KubitTooltip>
  );
};

export default UsersFilterLabel;
